import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../index";
import { DataStatus } from "../../types";

export const getCompanies = (state: RootState) => state.companies.data;

const getCompaniesStatus = (state: RootState) => state.companies.status;

export const getIsCompaniesLoaded = createSelector(
  getCompaniesStatus,
  (status) => status === DataStatus.succeeded
);

/**
 * Company name by company id, for callers that hold ids only (the nav bar reads the
 * `custom:company_ids` claim, which carries UUIDs). Companies without a name are left out
 * so the caller's own fallback applies.
 */
export const getCompanyNameById = createSelector(getCompanies, (companies) =>
  companies.reduce<Record<string, string>>(
    (names, { id, name }) => (name ? { ...names, [id]: name } : names),
    {}
  )
);

export const getIsCompaniesLoadingError = createSelector(
  getCompaniesStatus,
  (status) => status === DataStatus.failed
);
